module.exports = __webpack_public_path__ + "static/img/customer12.35f68ebd.png";